import { render, staticRenderFns } from "./CarouselBar.vue?vue&type=template&id=45c535a1&scoped=true&"
import script from "./CarouselBar.vue?vue&type=script&lang=js&"
export * from "./CarouselBar.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBar.vue?vue&type=style&index=0&id=45c535a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c535a1",
  null
  
)

export default component.exports